var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneric = function SvgGeneric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.582 4.614a.313.313 0 0 1 .44-.046l2.747 2.235c.134.109.154.306.045.44l-7.45 9.156a.313.313 0 0 1-.135.096l-3.236 1.172a.313.313 0 0 1-.416-.339l.489-3.406a.313.313 0 0 1 .067-.153l7.449-9.155Zm-6.909 9.483-.402 2.804 2.663-.965 5.707-7.014-2.261-1.84-5.707 7.015Zm9.458-7.006-1.095 1.345-2.261-1.84 1.095-1.345 2.26 1.84ZM8.894 23.146l1.447-1.084-.484-.646-6.15 4.609a.404.404 0 0 0 .242.726h24.504v-.807H13.756c-.186-.712-.853-1.291-1.685-1.734-.827-.44-1.916-.802-3.177-1.064Zm-.876.657L5.16 25.944h7.732c-.17-.321-.546-.673-1.2-1.021-.883-.47-2.15-.863-3.674-1.12Z",
    fill: "#FA9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.979 20.68 1.212-.943.496.637-1.212.943-.496-.637ZM13.312 18.884l1.212-.943.496.637-1.213.943-.495-.637Z",
    fill: "#FA9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.979 20.68 1.212-.943.496.637-1.212.943-.496-.637ZM13.312 18.884l1.212-.943.496.637-1.213.943-.495-.637Z",
    stroke: "#FA9900",
    strokeWidth: 0.2,
    strokeLinejoin: "round"
  })));
};
export default SvgGeneric;